import { Vendor, VendorCategory, VendorPricingTier, ListingStatus } from '../../../types';

export class VendorMapper {
    private static safeJsonArray<T = any>(value: any, fallback: T[] = []): T[] {
        if (!value) return fallback;
        if (Array.isArray(value)) return value;
        if (typeof value === 'string') {
            try {
                const parsed = JSON.parse(value);
                return Array.isArray(parsed) ? parsed : fallback;
            } catch (e) {
                console.warn('[VendorMapper] Failed to parse JSON array', e);
                return fallback;
            }
        }
        return fallback;
    }

    static toDomain(row: any): Vendor {
        return {
            id: row.id,
            title: row.title || '',
            category: (row.category as VendorCategory) || VendorCategory.OTHER,
            location: row.location || '',
            description: row.description || '',
            images: VendorMapper.safeJsonArray(row.images),
            contactEmail: row.contact_email || undefined,
            contactPhone: row.contact_phone || undefined,
            website: row.website || undefined,
            facebook: row.facebook || undefined,
            instagram: row.instagram || undefined,
            pricingTier: (row.pricing_tier as VendorPricingTier) || VendorPricingTier.BASIC,
            status: (row.status as ListingStatus) || ListingStatus.PENDING,
            createdAt: row.created_at || new Date().toISOString().split('T')[0],
            updatedAt: row.updated_at || new Date().toISOString().split('T')[0],
            views: row.views || 0,
            clicks: row.clicks || 0,
            seller: {
                id: row.owner_id || '',
                name: row.seller_name || '', // Will be populated via JOIN or separate fetch if needed
                email: row.seller_email || '',
                isVerified: !!row.seller_is_verified,
                rating: 0,
                ratingCount: 0,
                memberSince: row.created_at || '',
                responseRate: 'N/A'
            },
        };
    }

    static toRow(vendor: Vendor, ownerId?: string): any {
        const finalOwnerId = ownerId || vendor.seller?.id || 'unknown';

        return {
            id: vendor.id,
            owner_id: finalOwnerId,
            title: vendor.title,
            category: vendor.category,
            location: vendor.location,
            description: vendor.description || '',
            images: JSON.stringify(vendor.images || []),
            contact_email: vendor.contactEmail || null,
            contact_phone: vendor.contactPhone || null,
            website: vendor.website || null,
            facebook: vendor.facebook || null,
            instagram: vendor.instagram || null,
            pricing_tier: vendor.pricingTier || 'basic',
            status: vendor.status || 'Čaká na schválenie',
            views: vendor.views || 0,
            clicks: vendor.clicks || 0,
            updated_at: new Date().toISOString()
        };
    }
}
